import customer1 from "./images/customers/d34f5a16-74e6-40d7-b9e9-3883c8aaff08.jpeg";
import customer3 from "./images/customers/04dbb8de-bad0-44b2-93fe-3437ceaece7b.jpeg";
import customer2 from "./images/customers/8ba732a2-4caa-435c-acee-cc3260e01e1b.jpeg";

import logo from "./images/logo.svg";

import startSectionIcon from "./images/section-icons/power.svg"
import howWeHelpIcon from "./images/section-icons/money-back.svg"
import consultIcon from "./images/section-icons/consulting.svg"
import qualityIcon from "./images/section-icons/quality.svg"
import reliabilityIcon from "./images/section-icons/reliability.svg"
import organizationIcon from "./images/section-icons/organization.svg"
import budgetIcon from "./images/section-icons/budget.svg"
import chinaIcon from "./images/flags/china.svg"
import cyprusIcon from "./images/flags/cyprus.svg"
import russiaIcon from "./images/flags/russia.svg"

import { BsShieldCheck, BsClipboardCheck, BsFileEarmarkText, BsBank, BsTelephone, BsArrowRightCircle, BsCheckCircle } from 'react-icons/bs';

const lawPageData = {
  banner: {
    title: "Юридическая поддержка, на которую можно опереться",
    subtitle:
      "Когда ситуация кажется сложной, важно иметь рядом профессионалов. Мы помогаем разобраться в деталях, защитить ваши интересы и выстроить понятную стратегию действий.",
    btn: "Получить бесплатную консультацию",
  },

  services: {
    title: "Чем мы можем быть полезны",
    subtitle:
      "Берём на себя решение правовых задач — от первого анализа до представительства и результата.",
    items: [
      {
        icon: BsShieldCheck,
        title: "Консультация юриста",
        text:
          "На первом этапе бесплатно разбираем вашу ситуацию, отвечаем на вопросы и объясняем возможные варианты развития.",
      },
      {
        icon: BsClipboardCheck,
        title: "Анализ ситуации и документов",
        text:
          "Изучаем договоры, переписку и иные материалы, выявляем риски и оцениваем реальные перспективы дела.",
      },
      {
        icon: BsFileEarmarkText,
        title: "Подготовка юридических документов",
        text:
          "Составляем заявления, обращения и жалобы с учётом законодательства и конкретных обстоятельств.",
      },
      {
        icon: BsBank,
        title: "Представительство и защита",
        text:
          "Представляем ваши интересы в судах, государственных органах и на переговорах до достижения результата.",
      },
    ],
  },

  howGetHelp: {
    title: "Как проходит работа",
    subtitle:
      "Процесс взаимодействия выстроен просто и понятно — без лишней бюрократии.",
    items: [
      {
        step: "1",
        text:
          "Вы обращаетесь к нам любым удобным способом — через сайт или по телефону.",
      },
      {
        step: "2",
        text:
          "Кратко описываете ситуацию и передаёте документы, если они есть.",
      },
      {
        step: "3",
        text:
          "Получаете бесплатную консультацию и разъяснение возможных шагов.",
      },
      {
        step: "4",
        text:
          "Совместно с юристом формируете дальнейший план действий.",
      },
    ],
  },

  whyWe: {
    title: "Почему нам доверяют",
    descr:
      "Мы ориентированы не на формальные советы, а на реальную помощь и результат.",
    list: [
      "Практикующие юристы и адвокаты с опытом сопровождения сложных дел.",
      "Бесплатная первичная консультация без обязательств.",
      "Индивидуальный подход с учётом вашей ситуации.",
      "Прозрачные условия работы и понятная стоимость услуг.",
    ],
  },

  contact: {
    title: "Бесплатная консультация юриста",
    subtitle:
      "Оставьте заявку, и специалист свяжется с вами для первичного разбора ситуации. Это бесплатно и помогает понять, как действовать дальше без лишних рисков.",
  },

  whatYouGet: {
    title: "Что вы получите в результате",
    afterListText:
      "Отправляя форму, вы подтверждаете согласие с нашей Политикой конфиденциальности и Пользовательским соглашением. Ссылки на документы доступны прямо в форме.",
    items: [
      "Персональный разбор вашей правовой ситуации",
      "Понимание возможных сценариев и последствий",
      "Чёткий план первоочерёдных действий",
      "Рекомендации по документам, срокам и дальнейшим шагам",
    ],
  },
};

const bannerData = function slidesData() {
  return {
    icon: startSectionIcon,
    title: "Помогаем вернуть утраченные средства",
    firstBlock: "Профессионально. Законно. С фокусом на результат",
    secondBlock:
      "Если вы столкнулись с проблемами при работе с брокером или финансовой платформой, мы поможем разобраться в ситуации и выстроить реальный путь возврата средств. От анализа кейса до практических шагов — вы не остаётесь с проблемой один на один.",
    btn: "Начать процесс возврата",
    logo: logo,
    cFtitle: "Бесплатная консультация специалиста",
    cFtext:
      "Оставьте свои контактные данные — мы свяжемся с вами, оценим ситуацию и подскажем возможные варианты действий"
  };
};

const howTo = function howToStartData() {
  const colors = ["#731425", "#0d0d0d"];

  return {
    icon: howWeHelpIcon,
    title: "Как Alectu помогает вернуть средства",
    descr:
      "Alectu — команда, которая сопровождает клиентов в спорах с брокерами и финансовыми платформами: от первичной оценки до результата. Мы быстро собираем факты, фиксируем доказательства и выстраиваем понятную стратегию возврата — без лишних обещаний и запутанных формулировок.",
    list_title: "Что вы получаете, сотрудничая с нами:",
    list: [
      {
        title: "Бесплатная первичная оценка",
        text: "Изучаем вводные данные и подсказываем реалистичные сценарии возврата.",
        color: colors[0],
      },
      {
        title: "Chargeback и банковские процедуры",
        text: "Сопровождаем процесс возврата через банк там, где это применимо.",
        color: colors[0],
      },      
      {
        title: "Переговоры и досудебное урегулирование",
        text: "Если возможно — добиваемся решения без суда, экономя ваше время и ресурсы.",
        color: colors[0],
      },      
      {
        title: "Чёткий план действий",
        text: "Формируем пошаговую стратегию под ваш кейс и объясняем каждый шаг простыми словами.",
        color: colors[1],
      },
      {
        title: "Сбор и упаковка доказательств",
        text: "Помогаем систематизировать переписки, чеки, выписки, скриншоты и другую важную информацию.",
        color: colors[0],
      },
      {
        title: "Подготовка документов",
        text: "Готовим заявления, обращения и претензии с учётом нюансов конкретной ситуации.",
        color: colors[1],
      },

      {
        title: "Работа с транзакциями и маршрутами платежей",
        text: "Анализируем цепочку переводов и помогаем оформить действия для возврата в разных сценариях.",
        color: colors[1],
      },

      {
        title: "Сопровождение «под ключ»",
        text: "Ведём дело от старта до результата: вы всегда понимаете, на каком этапе находитесь.",
        color: colors[1],
      },
      {
        title: "Прозрачность и контроль",
        text: "Регулярные обновления по статусу и понятные ответы без «юридического тумана».",
        color: colors[0],
      },
    ],
    afterText:
      "Оставьте заявку — мы уточним детали и предложим оптимальный порядок действий именно для вашего случая.",
  };
};

const pricingData = function pricingData() {
  return { 
    title: "Сколько стоят наши услуги",
    descr:
      "Мы принципиально отказались от фиксированных тарифов и предоплаты. Наша модель работы построена так, чтобы ваши интересы и наши были полностью совпадающими.",
    //list_title: "Как это работает на практике:", 
    icon: budgetIcon,
    list: [
      {
        title: "Бесплатный старт",
        text: "Первичная консультация, анализ ситуации и оценка перспектив возврата проводятся бесплатно. Вы ничего не платите на этапе принятия решения.",
      },
      {
        title: "Оплата только за результат",
        text: "Мы получаем вознаграждение исключительно в случае успешного возврата средств. Если деньги не возвращены — вы нам ничего не должны.",
      },
      {
        title: "Процент от возвращённой суммы",
        text: "Стоимость наших услуг рассчитывается как заранее согласованный процент от реально возвращённых средств, без скрытых комиссий и дополнительных платежей.",
      },
      {
        title: "Отказ от бесперспективных дел",
        text: "Если анализ показывает, что шансы на возврат минимальны, мы честно сообщаем об этом сразу и не беремся за дело, чтобы не тратить ваше время и деньги.",
      },
      {
        title: "Максимальная мотивация результата",
        text: "Мы заинтересованы в возврате максимальной суммы, поскольку наш доход напрямую зависит от результата. Чем больше вернём вам — тем больше заработаем сами.",
      },
    ],
    afterText:
      "Такая модель сотрудничества исключает риски для клиента и делает процесс возврата максимально честным, прозрачным и выгодным для вас.",
    ctaTitle: "Хотите понять перспективы именно вашего случая? Оставьте заявку — первичный разбор бесплатный.",
    ctaDesc: "Мы работаем с клиентами из разных стран и взаимодействуем с финансовыми и юридическими структурами в нескольких юрисдикциях.\nНаличие офисов и партнёрских команд в разных регионах позволяет нам действовать быстрее и эффективнее.",
    ctaIcon: consultIcon,
    ctaAdresses: [
      { country: "Россия", city: "Москва", address: "Бизнес-центр «Белые Сады», ул. Летниковская, д. 10, стр. 2, офис 503", icon: russiaIcon },
      { country: "Китай", city: "Шанхай", address: "Shanghai International Finance CentreCentury Avenue, Pudong", icon: chinaIcon },
      { country: "Кипр", city: "Никосия", address: "Arch. Makariou III Ave 3, Nicosia 1065, Cyprus", icon: cyprusIcon },
    ]      
  };
}; 

const returnFundsData = function returnFundsData() {
  return {
    title: "Почему клиенты выбирают Alectu",
    descr:
      "Мы работаем по понятным правилам и берем на себя всю сложную часть процесса. Наша цель — реальный результат, а не пустые обещания.",
    list_title: "Наши ключевые преимущества:",
    icon: qualityIcon,
    list: [
      {
        title: "Работа на результат",
        text: "Мы беремся только за те дела, где видим реальные шансы на возврат средств. Если перспектив нет — мы честно скажем об этом сразу.",
      },
      {
        title: "Без предоплаты",
        text: "Вы не платите авансом. Наше вознаграждение зависит исключительно от успешного возврата ваших денег.",
      },
      {
        title: "Комплексный подход",
        text: "Мы используем юридические, финансовые и технические инструменты для повышения эффективности возврата средств.",
      },
      {
        title: "Полная прозрачность",
        text: "Вы всегда знаете, на каком этапе находится дело и какие действия предпринимаются для достижения результата.",
      },
      {
        title: "Минимальное участие клиента",
        text: "Мы берем на себя всю рутину и взаимодействие с организациями — от вас требуется минимум времени и усилий.",
      },
    ], 
    afterText:
      "С Alectu вы получаете не просто консультацию, а профессиональное сопровождение до финального результата."
  };
};

const whyWe = function whyWe() {
  const colors = ["#25c560", "#eac433"];
  return {
    title: "Как проходит процесс возврата средств",
    descr:
      "Мы выстроили понятный и прозрачный алгоритм работы, чтобы вы с самого начала понимали, какие шаги предстоят и на каком этапе находится ваше дело.",
    icon: consultIcon,
    list: [
      {
        text: "Оставляете заявку и описываете ситуацию",
        color: colors[0],
      },
      {
        text: "Мы анализируем ваш кейс и проводим бесплатную консультацию",
        color: colors[1],
      },
      {
        text: "Формируем стратегию и заключаем договор на сопровождение",
        color: colors[0],
      },
      {
        text: "Запускаем процесс возврата и доводим дело до результата",
        color: colors[1],
      },
    ],
    subtitle: "Максимально просто и без лишних рисков",
    subdescr:
      "Вы всегда понимаете, что происходит, какие действия предпринимаются и какие перспективы есть у вашего дела. Мы сопровождаем вас на каждом этапе.",
    cFtitle: "Получить бесплатную консультацию",
  };
};

const aboutUs = {
    title: "О компании \"Alectu\"",
    icon: organizationIcon,
    descr:
      "Alectu — это команда специалистов, которая более десяти лет помогает клиентам возвращать утраченные средства. За годы практики мы столкнулись с большинством существующих схем финансового мошенничества и выстроили эффективную систему работы, ориентированную на реальный результат.",
    subtitle: "",
    subdescr:
      "Мы постоянно развиваем наши методы и инструменты. В последние годы особое внимание уделяется возврату цифровых активов. Используемые нами технологии объединяют юридическую экспертизу и современные аналитические решения, что позволяет выявлять движение средств и работать даже со сложными случаями.",
    subdescr2:
      "Мы не даём пустых обещаний и не беремся за бесперспективные дела. Подход Alectu основан на честной оценке ситуации, прозрачности действий и профессиональном сопровождении клиента на каждом этапе.",
  };


const secondData = function secondData() {
  return {
    titleLeft: "Don't waste your time. It's time to get your money back!",
    titleRight: "Оставить заявку на бесплатную консультацию",
    textLeft: "Regardless of who stole your money, a fraudulent broker, bookmaker or casino, the time factor is very important. Experienced professionals of our company will take all the necessary measures and get your money back.",
    textRight:
      "",
    btn: "Отправить заявку",
  };
};

const customersData = {
    title: "Отзывы клиентов Alectu",
    icon: reliabilityIcon,
    desc:
      "Результаты нашей работы лучше всего подтверждают слова людей, которые уже прошли путь возврата средств вместе с Alectu.",
    list: [
      {
        img: customer1,
        author: "Григорий Воронов",
        text: "Я не впервые сталкиваюсь с юридическими компаниями, поэтому достаточно критично подхожу к выбору специалистов. В моём случае речь шла о возврате средств от брокера. Команда Alectu сразу обозначила реальную картину, без иллюзий, и взяла дело в работу. Отмечу чёткую коммуникацию, скорость и результат — деньги удалось вернуть в полном объёме.",
      },

      {
        img: customer3,
        author: "Ирина Зайцева",
        text: "После потери денег я была в растерянности и не понимала, есть ли вообще шанс что-то вернуть. В Alectu подробно разобрали мою ситуацию, объяснили этапы и возможные риски. Всё происходило прозрачно, без давления. Уже через несколько недель средства были возвращены. Для меня это был огромный стресс, который команда помогла пройти спокойно.",
      },

      {
        img: customer2,
        author: "Роман Дроздов",
        text: "Когда брокер заблокировал вывод средств, я понял, что самостоятельно ситуацию не решить. В Alectu оперативно подключились к делу, подготовили необходимые обращения и сопровождали процесс до конца. Особенно понравилось, что мне не приходилось постоянно вникать в детали — специалисты брали всё на себя. В итоге счёт был закрыт, а деньги возвращены.",
      },
    ],
};

const PrivacyPolicyData = (
    <>
      <h5>1. Общие положения</h5>
      <p>
        Настоящая Политика описывает, как сайт <strong>Alectu.com</strong> обрабатывает персональные данные
        пользователей формы обратной связи и иных веб-форм. Мы руководствуемся принципами необходимости,
        законности, прозрачности и минимизации данных.
      </p>

      <h5>2. Состав обрабатываемых данных</h5>
      <p>
        При отправке формы мы можем обрабатывать: имя, адрес электронной почты, номер телефона, содержимое
        сообщения, а также технические данные (IP-адрес, user-agent, реферер, параметры устройства, cookies).
        Данные указываются пользователем добровольно, за исключением технических данных, собираемых автоматически
        для функционирования сервиса, обеспечения безопасности и аналитики.
      </p>

      <h5>3. Цели обработки</h5>
      <ul>
        <li>Идентификация обращений и коммуникация с пользователем;</li>
        <li>Подготовка консультаций и ответов на запросы;</li>
        <li>Исполнение пользовательских запросов и улучшение качества сервиса;</li>
        <li>Аналитика использования сайта и предотвращение злоупотреблений;</li>
        <li>Соблюдение требований применимого права (включая хранение логов обращений).</li>
      </ul>

      <h5>4. Правовые основания</h5>
      <p>
        Обработка осуществляется на основании добровольного волеизъявления пользователя (отправка формы),
        а также на основании законного интереса владельца сайта — предоставлять и улучшать сервис,
        обеспечивать его безопасность и надёжность.
      </p>

      <h5>5. Передача и хранение данных</h5>
      <p>
        Данные могут храниться во внутренней инфраструктуре и/или у квалифицированных поставщиков
        облачных и почтовых сервисов. Мы применяем организационные и технические меры защиты, включая
        разграничение доступа, шифрование каналов связи и аудит событий безопасности.
      </p>

      <h5>6. Сроки обработки</h5>
      <p>
        Данные хранятся не дольше, чем это необходимо для целей, указанных в настоящей Политике, после чего
        удаляются или анонимизируются. Отдельные сведения могут храниться дольше, если это требуется законом
        или необходимо для защиты прав и законных интересов.
      </p>

      <h5>7. Права пользователя</h5>
      <ul>
        <li>Получать информацию об обработке своих данных;</li>
        <li>Запрашивать уточнение, обновление или удаление предоставленных данных в пределах закона;</li>
        <li>Ограничивать обработку и возражать против отдельной обработки, если такое право предоставлено законом;</li>
        <li>Отзывать согласие на обработку данных, если обработка основана на согласии.</li>
      </ul>

      <h5>8. Cookies и аналитика</h5>
      <p>
        Мы можем использовать cookies и схожие технологии для персонализации интерфейса, аналитики трафика и
        улучшения производительности. Пользователь может управлять cookies в настройках браузера; ограничение
        cookies может повлиять на корректность работы отдельных функций сайта.
      </p>

      <h5>9. Обновления Политики</h5>
      <p>
        Политика может периодически обновляться для отражения изменений сервиса и требований законодательства.
        Актуальная версия всегда доступна на сайте <strong>Alectu.com</strong>.
      </p>
    </> );

const TermsOfUseData = (
        <>  
      <h5>1. Предмет соглашения</h5>
      <p>
        Настоящее Соглашение регулирует использование пользователем веб-сайта <strong>Alectu.com</strong> и его
        функциональности (включая формы обратной связи). Используя сайт, пользователь подтверждает, что
        ознакомился с Соглашением и обязуется его соблюдать.
      </p>

      <h5>2. Использование сайта</h5>
      <ul>
        <li>Пользователь обязуется предоставлять достоверные сведения при заполнении форм;</li>
        <li>Запрещено нарушать безопасность, пытаться получить несанкционированный доступ, размещать вредоносные данные;</li>
        <li>Запрещено использовать сайт для рассылки спама, мошенничества и иных противоправных действий;</li>
        <li>Владелец сайта вправе ограничить доступ при нарушении Соглашения или угрозе безопасности сервиса.</li>
      </ul>

      <h5>3. Консультации и информация</h5>
      <p>
        Материалы на сайте носят информационный характер и не являются индивидуальной юридической рекомендацией.
        Окончательные выводы и действия формируются с учётом предоставленных пользователем данных и могут требовать
        дополнительной проверки документов и обстоятельств.
      </p>

      <h5>4. Интеллектуальная собственность</h5>
      <p>
        Контент сайта (тексты, графика, логотипы, интерфейс) охраняется правом. Пользователь получает ограниченную
        неисключительную лицензию на личное использование сайта и не вправе копировать или распространять контент
        без разрешения правообладателя.
      </p>

      <h5>5. Ограничение ответственности</h5>
      <p>
        Сайт предоставляется «как есть». Владелец сайта стремится к бесперебойной работе сервиса, однако не
        гарантирует его абсолютную доступность или безошибочность. Ответственность за корректность введённых
        пользователем данных несёт пользователь.
      </p>

      <h5>6. Взаимодействие с третьими лицами</h5>
      <p>
        Сайт может содержать ссылки на сторонние ресурсы. Мы не контролируем их содержание и политику обработки
        данных и не несём ответственность за действия третьих лиц.
      </p>

      <h5>7. Изменения условий</h5>
      <p>
        Владелец сайта может обновлять Соглашение в любой момент для отражения изменений сервиса. Продолжение
        использования сайта означает согласие с обновлёнными условиями.
      </p>
    </> );

const footerData = function footerData() {
  return {
    brand: {
      logo,
      alt: "Alectu",
      tagline:
        "Юридическая и организационная поддержка для возврата средств от брокера. Работаем системно: от первичного анализа до сопровождения действий по вашему делу.",
      trust: [
        "Первичный разбор — бесплатно",
        "Оплата — после выполненной работы / результата*",
        "Понятный план действий и отчётность по этапам",
      ],
    },

    columns: [
      {
        title: "Навигация",
        type: "links",
        items: [
          { label: "О компании", href: "#about" },
          { label: "О процедуре возврата", href: "#howToStart" },
          { label: "Почему выбирают нас", href: "#benefits" },
          { label: "Стоимость", href: "#pricing" },
          { label: "Оставить заявку", href: "#contact-cta" },
        ],
      },
      {
        title: "Что вы получите",
        type: "list",
        items: [
          { label: "Оценку перспектив именно вашего случая" },
          { label: "Чек-лист доказательств и необходимых документов" },
          { label: "Пошаговую стратегию с приоритетами и сроками" },
          { label: "Сопровождение обращений и коммуникаций по делу" },
        ],
      }
    ],

    bottom: {
      mini: [
        {
          label: "Подход:",
          text: "анализ → стратегия → действия → сопровождение → контроль результата",
        },
        {
          label: "Примечание:",
          text: "* Условия оплаты зависят от кейса и фиксируются в договоре после первичного анализа.",
        },
      ],
      badges: ["Case-first", "Transparent process", "No upfront fees"],
      copyright:
        "© {year} Alectu. Все права защищены.",
    },
  };
};

const reliableData = function reliableData() {
  return {
    title: "Alectu - a reliable partner, assistant and source of information about finance and investment",
    descr: "Get all the information you need to be successful and safe in the finance industry. If you already have a bad experience of interacting with scammers, we will help you get your money back.",
  };
};

export {
  pricingData,
  returnFundsData,
  bannerData,
  howTo,
  whyWe,
  aboutUs,
  secondData,
  customersData,
  PrivacyPolicyData,
  TermsOfUseData,
  reliableData,
  footerData,
  lawPageData
};